<dt-loading-indicator *ngIf="loading"></dt-loading-indicator>
<div class="cdk-visually-hidden" role="status" aria-live="polite" aria-atomic="true">
  {{ loadingAnnouncement }}
</div>
<div cdkTrapFocus>
  <dt-messages></dt-messages>
  <router-outlet></router-outlet>
</div>
